import React from 'react';
import appStoreBadge from '../App_Store_Badge.svg';
import googleBadge from '../Google_Badge.svg';
import {
  HeroSection,
  HeroVideo,
  HeroOverlay,
  HeroTitle,
  HeroSubtitle,
  ButtonContainer,
  StoreBadges,
  StoreBadge,
} from '../styles/hero';

function Hero() {
  return (
    <HeroSection id="hero" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
      <HeroVideo autoPlay muted loop playsInline>
        <source src="/football.mp4" type="video/mp4" />
        <source src="/footballHero.webm" type="video/webm" />
        <p>Your browser does not support the video tag.</p>
      </HeroVideo>
      <HeroOverlay>
        <HeroTitle
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Best in Sports Fines Management
        </HeroTitle>
        <HeroSubtitle
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.8 }}
        >
          Your ultimate destination for managing team fines, accountability, and team
          spirit. Join a growing community of sports teams pushing limits and having fun.
        </HeroSubtitle>
        <ButtonContainer>
          <StoreBadges>
            <a
              href="https://apps.apple.com/gb/app/playfair/id6754043983"
              target="_blank"
              rel="noreferrer"
            >
              <StoreBadge src={appStoreBadge} alt="Download on the App Store" />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.davebuck98.footyfines&hl=en_GB"
              target="_blank"
              rel="noreferrer"
            >
              <StoreBadge src={googleBadge} alt="Get it on Google Play" />
            </a>
          </StoreBadges>
        </ButtonContainer>
      </HeroOverlay>
    </HeroSection>
  );
}

export default Hero;
